import { HeroImage } from "modules/sections/HeroImage";
import type { HeroImageProps } from "modules/sections/HeroImage";
import type { ReactStoryblokComponent } from "modules/storyblok/types";

const HeroImageSectionAdapter = ({
  blok: { srcMobile, alt, srcDesktop, heading, subHeading },
}: ReactStoryblokComponent<HeroImageProps>) => (
  <HeroImage srcDesktop={srcDesktop} alt={alt} srcMobile={srcMobile} heading={heading} subHeading={subHeading} />
);
export default HeroImageSectionAdapter;
